import { createSlice } from '@reduxjs/toolkit';
import { emptyString } from '~/constants/string';
import { extraReducers } from './extraReducers';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export interface AuthState {
  company: {
    id: string;
    label: string;
    value: string;
    timeClockingLevels: string[];
  };
  branch: {
    value: string | number;
    label: string;
    isAutoStartStop: boolean;
  };
  loading: boolean;
  userId: string;
  employee?: {
    firstName: string;
    lastName: string;
    employeeId: string;
  };
}

const initialState: AuthState = {
  company: {
    id: emptyString,
    label: emptyString,
    value: emptyString,
    timeClockingLevels: [],
  },
  branch: {
    value: emptyString,
    label: emptyString,
    isAutoStartStop: false,
  },
  loading: false,
  userId: emptyString,
};

export const { actions, reducer } = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearAuth: (state) => {
      state.branch = {
        value: emptyString,
        label: emptyString,
        isAutoStartStop: false,
      };
      state.company = {
        id: emptyString,
        label: emptyString,
        value: emptyString,
        timeClockingLevels: [],
      };
      state.userId = emptyString;
    },
    setEmployee: (state, data) => {
      state.employee = data.payload;
    },
  },
  extraReducers: extraReducers,
});

export const { clearAuth, setEmployee } = actions;

const persistConfig = {
  key: 'auth',
  version: 1,
  storage,
};

export const persistReducerAuth = persistReducer(persistConfig, reducer);
